import styles from './TabLabel.module.css';

const TabLabel = (props) => {
  return (
    <h6 className={styles.tabLabel}>{props.children}</h6>
  );
}

export default TabLabel;